/* lib/api/dealers.js — раздел «Дилеры» Админки (#509). Контракт — work/dealers/contract.json.
 *
 * Staff-контур, как salesConsole.js: смотрит на чужие пространства, заголовок пространства
 * вкладки ему не нужен — цель выдачи приходит явным workspace_id в теле.
 * apiFetch не бросает на HTTP-кодах: {ok, status, data}. Деньги и ставки — строки ("13410.00").
 */

import { apiFetch, downloadFile } from './client.js';
import { withIdempotencyKey } from './idempotency.js';

const BASE = '/api/dealers/';

export const listDealers = () => apiFetch(BASE);
export const getDealer = (id) => apiFetch(`${BASE}${id}/`);
export const createDealer = (body) => apiFetch(BASE, { method: 'POST', body });
export const updateDealer = (id, body) => apiFetch(`${BASE}${id}/`, { method: 'PATCH', body });
export const listDealerPlans = () => apiFetch(`${BASE}plans/`);

export const searchDealerClients = (q) => apiFetch(`${BASE}clients/?q=${encodeURIComponent(q)}`);
export const getDealerClient = (userId) => apiFetch(`${BASE}clients/${userId}/`);
export const assignClient = (userId, dealerId) =>
  apiFetch(`${BASE}clients/${userId}/assign/`, { method: 'POST', body: { dealer_id: dealerId } });
export const unassignClient = (userId) =>
  apiFetch(`${BASE}clients/${userId}/unassign/`, { method: 'POST', body: {} });

export const previewGrant = (body) => apiFetch(`${BASE}grants/preview/`, { method: 'POST', body });
// Ключ — на попытку: повтор с тем же ключом вернёт ту же выдачу (200, idempotent_replay).
export const createGrant = (body, key) =>
  apiFetch(`${BASE}grants/`, withIdempotencyKey({ method: 'POST', body }, key));
export const listGrants = ({ dealer = '', status = '', month = '', plan = '' } = {}) => {
  const q = new URLSearchParams();
  if (dealer) q.set('dealer', dealer);
  if (plan) q.set('plan', plan);
  if (status) q.set('status', status);
  if (month) q.set('month', month);
  const s = q.toString();
  return apiFetch(`${BASE}grants/${s ? `?${s}` : ''}`);
};
export const previewCancel = (grantId) => apiFetch(`${BASE}grants/${grantId}/cancel/`);
export const cancelGrant = (grantId) =>
  apiFetch(`${BASE}grants/${grantId}/cancel/`, { method: 'POST', body: {} });

export const getStatement = (dealerId) => apiFetch(`${BASE}${dealerId}/statement/`);
// Ключ — на попытку: повтор после сбоя сети вернёт ту же оплату (иначе долг дилера занизился бы).
export const addDealerPayment = (dealerId, body, key) =>
  apiFetch(`${BASE}${dealerId}/payments/`, withIdempotencyKey({ method: 'POST', body }, key));
export const deleteDealerPayment = (paymentId) =>
  apiFetch(`${BASE}payments/${paymentId}/`, { method: 'DELETE' });
export const downloadDealerCsv = (dealerId) =>
  downloadFile(`${BASE}${dealerId}/export.csv`, { filename: `dealer-${dealerId}-clients.csv` });

// Отчёт «Заведения» (#528): дилеру — свои клиенты (сервер сужает сам), нашему — дилер или все.
const venueQuery = ({ dealer = '', attention = false, q: search = '' } = {}) => {
  const q = new URLSearchParams();
  if (dealer) q.set('dealer', dealer);
  if (attention) q.set('attention', '1');
  if (String(search).trim()) q.set('q', String(search).trim());
  const s = q.toString();
  return s ? `?${s}` : '';
};
export const listVenues = (opts) => apiFetch(`${BASE}venues/${venueQuery(opts)}`);
export const downloadVenuesCsv = (opts) =>
  downloadFile(`${BASE}venues/export.csv${venueQuery(opts)}`, { filename: 'dealer-venues.csv' });

// Сотрудники дилера (наша сторона, право «настройка»).
export const listDealerMembers = (dealerId) => apiFetch(`${BASE}${dealerId}/members/`);
export const addDealerMember = (dealerId, email) =>
  apiFetch(`${BASE}${dealerId}/members/`, { method: 'POST', body: { email } });
export const removeDealerMember = (memberId) =>
  apiFetch(`${BASE}members/${memberId}/remove/`, { method: 'POST', body: {} });

// Режим дилера: своё (сервер сам сужает до дилера сотрудника).
export const getMine = () => apiFetch(`${BASE}mine/`);
export const listMineClients = () => apiFetch(`${BASE}mine/clients/`);
export const listMineInvites = () => apiFetch(`${BASE}mine/invites/`);
export const createMineInvite = (label) =>
  apiFetch(`${BASE}mine/invites/`, { method: 'POST', body: { label } });
export const revokeMineInvite = (inviteId) =>
  apiFetch(`${BASE}mine/invites/${inviteId}/revoke/`, { method: 'POST', body: {} });

// Приглашение глазами клиента: что за партнёр и подтверждение (switch — согласие уйти от прежнего).
export const getDealerInvite = (token) => apiFetch(`${BASE}invites/${encodeURIComponent(token)}/`);
export const acceptDealerInvite = (token, { switch: sw = false } = {}) =>
  apiFetch(`${BASE}invites/${encodeURIComponent(token)}/accept/`, { method: 'POST', body: { switch: sw } });
